import { useState } from 'react';

import './MedicalList.scss';
import { link } from '../../helpers/link';
import { getString } from '../../helpers/styles';

export default function MedicalList(props) {
  const [list, setList] = useState(props.list);
  const [letter, filterByLetter] = useState(null);

  const keys = Object.keys(list).sort();

  return (
    <section id="medicalList">
      {!props.hideHeader &&
        <>
          <h2 id="medicalList_title">Kwaaltjes en klachten A/Z</h2>

          <p>
            Hieronder is elk onderwerp betreffend jouw zwangerschap, kindje
            of andere gerelateerde content te vinden op alfabetische volgorde.
          </p>
        </>
      }

      <form
        id="medicalList_form"
        onSubmit={e => e.preventDefault()}>
        <input
          type="text"
          name="search"
          autoComplete="off"
          placeholder="Zoek op onderwerp..."
          onKeyUp={e => search(e.target.value.trim())}
        />
      </form>

      {!!keys.length &&
        <>
          <ul id="medicalList_letters_bar" onClick={e => filter(e)}>
            {keys.map(key =>
              <li
                key={key}
                data-id={key}
                className={getString('medicalList_letter_selected',
                  key === letter)}>
                {key}
              </li>
            )}
          </ul>

          <div
            id="medicalList_content"
            className={getString('medicalList_content_filtered', letter)}>
            <ul>
              {letter ? listItem(letter) : keys.map(key => listItem(key))}
            </ul>
          </div>
        </>
      }
    </section>
  );

  function filter(e) {
    const { id } = e.target.dataset;

    if (!id) return;

    if (id === letter) filterByLetter(null);
    else filterByLetter(id);
  }

  function listItem(key) {
    return (
      <li key={key}>
        <p className="medicalList_content_letter">
          {key}
        </p>

        <ul className="medicalList_content_section">
          {(list[key] || []).map((item, idx) =>
            <li key={idx}>{link(
              <div className="medicalList_content_item">
                <p className="medicalList_link">{item.title}</p>

                <div className="medicalList_image">
                  <img src={item.imageUrl} alt="category-image" />

                  <p>{item.parent.title}</p>
                </div>
              </div>, item.uri, props.nextLink)}
            </li>)}
        </ul>
      </li>
    );
  }

  function search(value) {
    if (!value) return setList(props.list);

    const lowerCasedValue = value.toLowerCase();

    const filteredList = keys.reduce((filteredList, key) => {
      const filteredItems = (list[key] || []).filter(item =>
        item.title.toLowerCase().includes(lowerCasedValue) ||
          item.parent.title &&
            item.parent.title.toLowerCase().includes(lowerCasedValue));

      if (filteredItems.length) filteredList[key] = filteredItems;

      return filteredList;
    }, {});

    setList(filteredList);
  }
}
